import { FooterAppMenuCloseNavigation, FooterAppMenuOpenState } from './footer-app-menu.model';

export class FooterAppMenuUtil {
    buildOpenMenuState(
        currentRoute: string | null,
        currentLang: string,
        isMenuPageEnabled: boolean
    ): FooterAppMenuOpenState {
        return {
            routeBeforeMenu: currentRoute,
            navigateCommands: isMenuPageEnabled ? [currentLang, 'mobile-menu'] : null
        };
    }

    buildCloseMenuNavigation(
        routeBeforeMenu: string | null,
        currentLang: string,
        isMenuPageEnabled: boolean
    ): FooterAppMenuCloseNavigation {
        if (!isMenuPageEnabled) {
            return this.createCloseMenuNavigation(null, null);
        }

        const storedRoute = this.buildStoredRouteUrl(routeBeforeMenu, currentLang);

        if (storedRoute) {
            return this.createCloseMenuNavigation(storedRoute, null);
        }

        return this.createCloseMenuNavigation(null, [currentLang, '/explore']);
    }

    buildStoredRouteUrl(routeBeforeMenu: string | null, currentLang: string): string | null {
        if (!routeBeforeMenu) {
            return null;
        }

        const routeParts = routeBeforeMenu.split('/').filter((part) => part);

        if (!routeParts.length) {
            return null;
        }

        routeParts[0] = currentLang;

        return `/${routeParts.join('/')}`;
    }

    private createCloseMenuNavigation(
        navigateByUrl: string | null,
        navigateCommands: string[] | null
    ): FooterAppMenuCloseNavigation {
        return {
            navigateByUrl,
            navigateCommands
        };
    }
}
